import script from "./TotalTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalTable.vue?vue&type=script&setup=true&lang=js"

import "./TotalTable.vue?vue&type=style&index=0&id=309176c3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-309176c3"]])

export default __exports__